var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#747F80"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.122 32.95h-1.976v-2.971c-.558-.147-1.1-.243-1.606-.431-2.866-1.069-4.602-3.113-5.188-6.117-.209-1.066-.111-2.15-.116-3.226 0-.013.013-.027.027-.054h1.94c0 .642.003 1.272 0 1.901a6.057 6.057 0 0 0 .325 1.996c1.26 3.699 5.826 5.172 8.962 2.918l-.703-.706a5.07 5.07 0 0 1-1.667.682c-2.847.615-5.693-1.493-5.902-4.39-.04-.575-.026-1.154-.031-1.732-.007-.747-.008-1.494-.011-2.24-.53-.537-1.058-1.076-1.59-1.61-.782-.786-1.568-1.569-2.351-2.353-.054-.054-.104-.11-.141-.15l1.37-1.37 16.657 16.66-1.369 1.36-2.777-2.783c-1.15.882-2.421 1.368-3.853 1.558v3.058ZM26.71 23.904c-.077-.071-.133-.121-.187-.175-2.973-2.972-5.944-5.947-8.921-8.915-.136-.136-.155-.242-.087-.418.798-2.04 2.908-3.36 5.024-3.132 2.31.247 4.07 1.881 4.436 4.13.045.28.07.566.07.85.006 1.933.004 3.866.002 5.798 0 .628-.096 1.24-.337 1.862ZM28.945 26.143c-.51-.508-.967-.96-1.417-1.422-.036-.037-.035-.144-.01-.2.384-.86.537-1.76.518-2.696-.012-.552-.002-1.106-.002-1.674h1.937c.014.022.029.035.029.047.01 1.475.117 2.961-.4 4.385-.188.515-.424 1.013-.655 1.56Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: -41.246,
    y: -41.246,
    width: 127.492,
    height: 127.492,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 20.623
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_6096_8575"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_6096_8575",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMute);
export default __webpack_public_path__ + "static/media/mute.d560b3ac40f1d5740f07c730da14e64d.svg";
export { ForwardRef as ReactComponent };